import { on } from "@ngrx/store";
import { PagesStore } from "../../pages.state";
import { QuoteCreateActions } from "./quote-create.actions";
import { initialQuoteCreateState } from "./quote-create.state";

// ============================================================================
// QUOTE CREATE REDUCER (array format for spreading in pages reducer)
// ============================================================================

const create = on(QuoteCreateActions.create, (state: PagesStore) => ({
    ...state,
    quoteCreate: { ...state.quoteCreate, creating: true },
}));

const createSuccess = on(QuoteCreateActions.createSuccess, (state: PagesStore) => ({
    ...state,
    quoteCreate: { ...state.quoteCreate, creating: false },
}));

const createFailure = on(QuoteCreateActions.createFailure, (state: PagesStore) => ({
    ...state,
    quoteCreate: { ...state.quoteCreate, creating: false },
}));

export const quoteCreateReducer = [
    create,
    createSuccess,
    createFailure,
];
